import type { TFunction } from 'i18next'

// "First in line", or "Place 3 in line · 2 ahead of you". The place is the
// server's (flight.bookings' queuePosition): the order promotion uses.
export function standbyPlaceLabel(t: TFunction, queuePosition: number | null | undefined): string | null {
  if (queuePosition === null || queuePosition === undefined) return null
  if (queuePosition <= 1) return t('booking.standby.first')
  return `${t('booking.standby.place', { place: queuePosition })} · ${t('booking.standby.behindYou', { count: queuePosition - 1 })}`
}
